import React from "react";
// ? Component/Pages
import Home from "./pages/Home";
import GameDetail from "./pages/GameDetail";
import Games from "./pages/Games";
import Nav from "./components/Navbar";
// ? Styles
import GlobalStyles from "./components/GlobalStyles";
// ? Router
import { Switch, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <GlobalStyles />
      <Nav />
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>

        <Route path="/games/:slug">
          <GameDetail />
        </Route>

        <Route path="/games" exact>
          <Games />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
